const normalizeEmail = (value) => (value || '').trim().toLowerCase()

// Case-insensitive email equality for Auth0 vs form/lookup comparisons.
// Empty values never match — otherwise '' === '' would trust lookup IDs.
function emailsMatch(a, b) {
  const left = normalizeEmail(a)
  const right = normalizeEmail(b)
  return !!left && left === right
}

export default emailsMatch
